import Button from "@/common/elements/Button";
import {
  ActionHeader,
  StyledActionControlContainer,
  StyledDarkSectionTitle,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import { labels } from "@/util/label";
import { useContext, useEffect, useRef, useState } from "react";
import { ReportModalContext } from "@/contexts/ReportModalContext";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { StaffingContainer } from "./styles.js";
import CreateStaffing from "../CreateStaffing/index.jsx";
import InmateHeader from "@/components/InmateHeader/index.jsx";
import StaffingBasicInfo from "./StaffingBasicInfo.jsx";
import { useDispatch, useSelector } from "react-redux";
import {
  setBookings,
  setBookingsFieldsEnabled,
  setDeleteAPIEmpty,
  setLastBookingsFromAPI,
  setShowBookings,
} from "@/slices/bookingsSlice.js";
import { setBookingsNull } from "@/slices/bookingsSlice.js";
import DataTable from "@/common/elements/DataTable/index.jsx";
import {
  hasCheckSecurity,
  isLoggedInStaff,
  isNonEmptyVariable,
  refreshLoggedInUserSecurity,
  toQueryString,
  validateStaffPassword,
} from "@/util/common_function.js";
import { Entity_types, Security_Types } from "@/util/permission_bits.js";
import { LABELS_CAPITAL } from "@/util/usePermissionMask.js";
import {
  mandatoryFields,
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
} from "@/util/common_variable.js";
import { Flex, Input, Spin, Popconfirm } from "antd";
import API_ENDPOINTS from "@/util/api.js";
import api from "@/services/axios_custom.js";
import notificationService from "@/util/notificationService.js";
import _ from "lodash";
import { ROUTES_PATH } from "@/routes.jsx";
import { setPath } from "@/slices/userDetailDetail.js";
import BookingsFilter from "../Bookings/filter.jsx";
import useDialog from "@/hooks/useDialog.jsx";
import useGridColumnConfig from "@/hooks/useGridColumnConfig";
import {
  deleteStaff,
  fetchAllSecurityListOfStaff,
  fetchStaffListAll,
  fetchStaffListAllActive,
} from "@/apis/staff/staffApi.js";
import NoAccess from "@/components/BookingsDetails/NoAccess.jsx";
const { Search } = Input;

const Staffing = ({ fromFolderDetails = false }) => {
  const { headerHeight } = useOutletContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    bookings,
    showBookings,
    bookingsFieldsEnabled,
    deleteAPis,
    LastBookingsFromAPI,
  } = useSelector((s) => s?.bookings);
  const { isDeleting } = useSelector((s) => s?.staff);
  const clientParamsList = useSelector((s) => s?.clientParams?.list);
  const { results: findResults, setResults: setFindResults } =
    useContext(ReportModalContext);
  const [loadingAPI, setLoadingAPI] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });
  const [tablePagination, setTablePagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });
  const [staffingData, setStaffingData] = useState({
    total: 0,
    headers: [
      { key: "staffId", text: labels.staffId },
      { key: "name", text: labels.name },
      { key: "division", text: labels.division },
      { key: "rank", text: labels.rank },
      { key: "badgeNumber", text: labels.badgeNumber },
      { key: "username", text: labels.username },
      { key: "agency", text: labels.agency },
    ],
    rows: [],
  });

  const sortKeyMap = {
    name: "lName",
    username: "userName",
  };

  const allFormRef = {
    personalFormRef: useRef(),
    organizationRankRef: useRef(),
    policeCentralUserRef: useRef(),
  };

  const nextBtnRef = useRef();
  const tabChangeRef = useRef();
  const cancelTokenSourceRef = useRef(null);
  const [saveVisible, setSaveVisible] = useState(false);
  const [saveEnable, setSaveEnable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTxt, setSearchTxt] = useState("");
  const [user, setUser] = useState(null);
  const [reportListData, setReportListData] = useState([]);
  const [filteredReportListData, setFilteredReportListData] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [reportListTotal, setReportListTotal] = useState();
  const [isFiltered, setIsFiltered] = useState(false);
  const [bookingSearchPayload, setBookingSearchPayload] = useState([
    { filterKey: "searchType", value: "Starts With" },
    { filterKey: "isActive", value: true },
  ]);

  const [sortInfo, setSortInfo] = useState({
    orderBy: "lName",
    direction: "asc",
  });
  const isPageRef = useRef(false);
  const skipListFetchRef = useRef(false);

  const { showDialog } = useDialog();

  // Config button (reorder/resize columns) for the main Staff search grid —
  // a deliberate deviation from legacy, same as Users' main list (see
  // docs/plans/grid-column-config-other-modules-rollout.md §3.1/§3.3/§3.4):
  // `StaffInterface.asp` (GetModuleName = "Staff") has no
  // CreateListEx/CreateListWithButtons for this grid at all — same
  // GetSearchPage-driven browse list architecture as Users, so nothing to
  // replicate either way. The user explicitly asked for it anyway.
  const {
    headers: staffingHeaders,
    isConfiguring,
    configButtonLabel,
    startConfiguring,
    confirmSave,
    discardChanges,
    dataTableRef,
  } = useGridColumnConfig("Staff:StaffList", staffingData.headers);

  useEffect(() => {
    dispatch(setShowBookings(false));

    dispatch(setPath("staff"));
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));

    if (isNonEmptyVariable(loginUser)) {
      setUser(() => loginUser);
    }

    const fj = sessionStorage.getItem("from-jacket");
    const jb = sessionStorage.getItem("jacket-before");

    if (
      isNonEmptyVariable(fj) &&
      fj == "true" &&
      isNonEmptyVariable(jb) &&
      jb == MODULES_LIST?.STAFF
    ) {
      dispatch(setShowBookings(true));
    } else if (fromFolderDetails == true) {
      setSaveVisible(true);
      dispatch(setShowBookings(true));
    } else {
      setSaveVisible(false);
    }
    // getStaffList();
    return () => {
      if (!!!fromFolderDetails) dispatch(setShowBookings(false));
      // dispatch(setBookingsNull());
      // dispatch(setBookingsFieldsEnabled(false));
    };
  }, []);

  useEffect(() => {
    // if (!showFilter) {
    //   getStaffList();
    // }

    if (skipListFetchRef.current) {
      skipListFetchRef.current = false;
      return;
    }

    if (!showBookings) {
      getStaffList();
      setSaveVisible(false);
    } else {
      if (bookingsFieldsEnabled) setSaveVisible(true);
    }
  }, [tablePagination, showBookings]);

  // Document Control's "Find" popup (staff search fields) hands its matched
  // rows back here via ReportModalContext instead of jumping to the first
  // record's detail view — show them all in this page's table. Skip the
  // effect above's default re-fetch since we already have the rows to show.
  useEffect(() => {
    if (!findResults) return;

    const rowData = findResults.map((a) => ({
      staffId: a.staffID,
      name: a?.name,
      badgeNumber: a?.badgeNumber,
      rank: a?.rank,
      division: a?.division,
      username: a.username,
      agency: a?.agency,
    }));

    if (showBookings) skipListFetchRef.current = true;
    dispatch(setShowBookings(false));
    setReportListData((prev) => ({ ...prev, rows: rowData }));
    setFilteredReportListData(findResults);
    setReportListTotal(findResults.length);
    setIsFiltered(true);
    setFindResults(null);
  }, [findResults]);

  const getStaffList = async (sort = sortInfo) => {
    try {
      setLoadingAPI(true);
      setStaffingData((prev) => ({ ...prev, rows: [] }));
      setFilteredReportListData([]);

      let url = `${API_ENDPOINTS.staff.searchStaff}?direction=${sort.direction}&orderBy=${sort.orderBy}`;

      const obj = {
        page: tablePagination.pageIndex,
        size: tablePagination.pageSize,
        top: 50,
      };

      const urlParam = toQueryString(obj);

      if (isNonEmptyVariable(urlParam)) {
        url += "&" + urlParam;
      }

      let payload = bookingSearchPayload;

      if (!isFiltered) {
        payload = [...bookingSearchPayload];
      }

      const result = await api.post(url, payload);
      let data = result?.data?.rows;

      if (data) {
        let rowData = data.map((a, i) => {
          let obj = {};
          obj.staffId = a.staffID;
          obj.name = a?.name;
          obj.badgeNumber = a?.badgeNumber;
          obj.rank = a?.rank;
          obj.division = a?.division;
          obj.username = a.username;
          obj.agency = a?.agency;
          return obj;
        });

        setReportListData((prev) => ({
          ...prev,
          rows: rowData,
        }));
      }
      // const injailList = result?.data?.rows?.filter(
      //   (r) => r?.currentLocation === "In Jail"
      // );
      if (!isFiltered) {
        setReportListTotal(result?.data?.total);
      }
      // setReportListData((prev) => ({
      //   ...prev,
      //   rows: result?.data?.rows,
      // }));
      setFilteredReportListData(() => result?.data?.rows);
    } catch (err) {
      setReportListData([]);
      setFilteredReportListData([]);
    } finally {
      setLoadingAPI(false);
    }
  };

  const getStaffByID = (staffid) => {
    dispatch(setBookingsNull());
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));
    setIsLoading(true);
    let staffId = staffid ? staffid : loginUser?.staffId;
    const url = API_ENDPOINTS.staff.staffByID + staffId;
    api
      .get(url)
      .then((res) => {
        if (isNonEmptyVariable(res?.data)) {
          dispatch(
            setBookings({
              ...res?.data,
              bookingLinkedDocuments: res?.data?.staffLinkedDocuments,
            }),
          );
          dispatch(
            setLastBookingsFromAPI({
              ...res?.data,
              bookingLinkedDocuments: res?.data?.staffLinkedDocuments,
            }),
          );
          dispatch(setShowBookings(true));
          dispatch(setBookingsFieldsEnabled(false));
          setSaveVisible(false);
        }
      })
      .catch(() => {
        notificationService.error("No record found");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleRowClick = (data, index) => {
    if (index !== undefined && index !== null) {
      if (!isNonEmptyVariable(data)) {
        return;
      }

      dispatch(setLastBookingsFromAPI(null));

      let staffId = data?.staffId;
      if (staffId) {
        getStaffByID(staffId);
      }
    }
  };

  const handleChangePagination = (pageIndex, pageSize) => {
    isPageRef.current = true;
    setTablePagination({ pageIndex, pageSize });
  };

  const getALLStaffList = () => {
    dispatch(fetchStaffListAllActive())
      .unwrap()
      .then(() => {})
      .catch((error) => console.log(error, "error"));
  };

  const preSaveStaffAction = () => {
    let validations = [Promise.resolve(true)];
    validations = [
      allFormRef?.personalFormRef?.current?.validateFields(),
      // allFormRef?.organizationRankRef?.current?.validateFields(),
    ];
    Promise.all(validations)
      .then(() => {
        if (!isNonEmptyVariable(bookings?.organization?.[0]?.agency)) {
          notificationService.error(
            "Validation Error",
            `Fill all mandatory fields in organization rank`,
          );

          setTimeout(() => {
            tabChangeRef.current?.onTabChange("organizational");
            // Move focus to the first error element
            setTimeout(() => {
              allFormRef?.organizationRankRef?.current?.validateFields();
              const firstErrorField = document.querySelector(`#agencyId`);

              firstErrorField?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              firstErrorField?.focus();
            }, 300);
          }, 0);
          return;
        }
        const data = _.cloneDeep(bookings);
        saveStaffAction(data);
      })
      .catch((err) => {
        let tabToChange = "personal-information";

        let requiredField = err?.errorFields[0]?.name[0];
        if (requiredField) {
          tabToChange =
            Object.keys(mandatoryFields).find((tab) =>
              mandatoryFields[tab].includes(requiredField),
            ) || "personal-information";
        }

        notificationService.error(
          "Validation Error",
          `Fill all mandatory fields in ${tabToChange
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}`,
        );

        setTimeout(() => {
          tabChangeRef.current?.onTabChange(tabToChange);
          // Move focus to the first error element
          setTimeout(() => {
            const firstErrorField = document.querySelector(`#${requiredField}`);

            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 300);
        }, 0);
      });
  };

  function cleanObject(obj) {
    if (Array.isArray(obj)) {
      // If it's an array, recursively clean each item and filter out empty values
      return obj
        .map(cleanObject) // Recursively clean each element
        .filter(
          (value) =>
            value !== undefined &&
            value !== null &&
            value !== "" &&
            (Array.isArray(value) ? value.length > 0 : true) &&
            (typeof value === "object" ? Object.keys(value).length > 0 : true),
        );
    } else if (typeof obj === "object" && obj !== null) {
      // If it's an object, recursively clean its properties
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const cleanedValue = cleanObject(value); // Recursively clean the value
        if (
          cleanedValue !== undefined &&
          cleanedValue !== null &&
          cleanedValue !== "" &&
          (typeof cleanedValue === "object"
            ? Object.keys(cleanedValue).length > 0
            : true)
        ) {
          acc[key] = cleanedValue; // Add only non-empty values
        }
        return acc;
      }, {});
    }
    // If it's a primitive value, return it as-is
    return obj;
  }

  const saveStaffAction = (payload) => {
    payload = {
      ...payload,
      staffLinkedDocuments: payload?.staffLinkedDocuments,
      jackets: [
        {
          ...((payload?.jackets && payload.jackets[0]) || {}),
          jacketId: payload?.["Folder ID"] || payload?.jacketId || null,
          staffJacket: true,
          orphanFlag: false,
        },
      ],
    };
    if (
      isNonEmptyVariable(payload?.isPoliceCentralUser) &&
      payload?.isPoliceCentralUser
    ) {
      if (!isNonEmptyVariable(payload?.username)) {
        notificationService.error("Validation Error", "User Name is Mandatory");
        setTimeout(() => {
          tabChangeRef.current?.onTabChange("police-central-userinfo");
          // Move focus to the first error element
          setTimeout(() => {
            // allFormRef?.policeCentralUserRef?.current?.validateFields();
            const firstErrorField = document.querySelector("#username");

            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 300);
        }, 0);
        return;
      }
      if (!isNonEmptyVariable(payload?.initialModule)) {
        notificationService.error(
          "Validation Error",
          "Initial Module is Mandatory",
        );
        setTimeout(() => {
          tabChangeRef.current?.onTabChange("police-central-userinfo");
          // Move focus to the first error element
          setTimeout(() => {
            // allFormRef?.policeCentralUserRef?.current?.validateFields();
            const firstErrorField = document.querySelector("#initialModule");

            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 300);
        }, 0);
        return;
      }

      if (!isNonEmptyVariable(payload?.password)) {
        payload.password = LastBookingsFromAPI?.password;
      }

      if (isNonEmptyVariable(payload?.password)) {
        const { valid, message } = validateStaffPassword(
          payload?.password,
          clientParamsList,
        );

        if (!valid) {
          notificationService.error(
            "Validation Error",
            message ||
              "Password must be at least 12 characters long and include uppercase, lowercase, number, and special character.",
          );
          return;
        }
      }
    }
    delete payload?.bookingLinkedDocuments;
    let cached = "";
    if (isNonEmptyVariable(payload?.bio)) {
      cached = payload?.bio[0]?.fName + " " + payload?.bio[0]?.lName;
      payload.staffDescriptionCached = cached;
    }

    setIsLoading(() => true);
    if (deleteAPis?.length) {
      try {
        deleteAPis?.forEach((d) => {
          if (payload?.staffId) d = d + `?staffId=${payload?.staffId}`;
          api.delete(d);
        });
      } catch (error) {
        notificationService.error("Error", "Error Deleting Staff Items");
        setIsLoading(() => false);
        return;
      }
    }
    const url = API_ENDPOINTS.staff.create;
    const preFinalPayload = cleanObject(payload);
    api
      .post(url, preFinalPayload)
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          if (!isNonEmptyVariable(payload?.staffId)) {
            dispatch(
              setBookings({
                staffId: res?.data?.id,
              }),
            );
            dispatch(
              setLastBookingsFromAPI({
                staffId: res?.data?.id,
              }),
            );
            getALLStaffList();
            notificationService.success(
              "Success",
              "New staff created successfully",
            );
            // dispatch(fetchStaffListAll())
          } else {
            dispatch(
              setBookings({
                ...payload,
              }),
            );
            dispatch(setLastBookingsFromAPI(payload));
            notificationService.success(
              "Success",
              "Staff updated successfully",
            );
            getALLStaffList();
            if (isLoggedInStaff(payload?.staffId)) {
              refreshLoggedInUserSecurity(dispatch);
            }
          }
          if (res?.data?.id) refreshSavedStaffData(res?.data?.id);
          setSaveVisible(false);
          setSearchTxt("");
          setIsLoading(() => false);
          dispatch(setBookingsFieldsEnabled(false));
        } else {
          let msg = res.data?.message;
          if (isNonEmptyVariable(msg)) {
            let errstart = msg.indexOf(":");
            let errend = msg.indexOf(")");
            if (errstart != -1 && errend != -1) {
              let errMsg = msg.substring(errstart + 2, errend);
              if (isNonEmptyVariable(errMsg)) {
                notificationService.error("Failed!", errMsg);
                return;
              }
            }
          }
          notificationService.error("Failed!", "New Staff created failed!");
        }
      })
      .finally(() => {
        setIsLoading(() => false);
        dispatch(setDeleteAPIEmpty());
      });
  };

  const cancelStaffAction = () => {
    dispatch(setBookings(LastBookingsFromAPI));
    dispatch(setBookingsFieldsEnabled(false));
    setSaveVisible(() => false);

    // Reverting the redux data alone doesn't clear a tab's own Antd Form
    // validation state (e.g. a triggered Password error) - each tab's
    // form ref exposes resetForm() for exactly this (see
    // PoliceCentralUserInfo.jsx/OrganizationalRank.jsx), but Cancel was
    // never actually calling it, so a still-invalid field kept showing
    // its error after Cancel even though the value reset underneath it.
    allFormRef?.personalFormRef?.current?.resetForm?.();
    allFormRef?.organizationRankRef?.current?.resetForm?.();
    allFormRef?.policeCentralUserRef?.current?.resetForm?.();
  };

  const modifyStaffAction = () => {
    dispatch(setBookingsFieldsEnabled(true));
    setSaveVisible(() => true);
  };

  const onNewStaffBtnAction = () => {
    // if (cancelTokenSourceRef.current) {
    //   cancelTokenSourceRef.current.cancel("new booking.");
    // }
    sessionStorage.setItem("jacket-before", MODULES_LIST?.STAFF);
    setIsLoading(() => false);
    navigate(ROUTES_PATH?.JACKET_SEARCH);
    dispatch(setBookingsNull());
  };

  const onSearch = (value) => {
    setIsLoading(() => false);
    if (value === "") {
      setSearchTxt("");
      return;
    }
    if (isNaN(value)) {
      notificationService.error("Please enter a valid Staff ID");
      return;
    } else {
      dispatch(setBookingsNull());
      setSearchTxt(value);
      setIsLoading(true);
      api
        .get(API_ENDPOINTS.staff.staffByID + value)
        .then((response) => {
          if (response.status === 200 && response.data) {
            dispatch(setBookings(response?.data));
            dispatch(setLastBookingsFromAPI(response?.data));
          } else {
            notificationService.error("No record found");
          }
        })
        .catch((error) => {
          notificationService.error("No record found");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  // Reloads the just-saved record from the server (to pick up any
  // server-assigned values, e.g. real IDs for newly added Client Params/
  // Security Rules records that only carried a local uuid until now)
  // without onSearch's null-then-fetch. onSearch's dispatch(setBookingsNull())
  // is right for the search box (switching to a possibly different record,
  // where showing stale data mid-load would be misleading) but wrong here:
  // it wiped the record saveStaffAction had *just* correctly written to
  // redux a moment earlier, leaving the header and Login Information fields
  // blank until this GET resolved - or permanently blank on a slow/failed
  // GET - even though the "Staff updated successfully" toast had already
  // fired.
  const refreshSavedStaffData = (id) => {
    api
      .get(API_ENDPOINTS.staff.staffByID + id)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(setBookings(response?.data));
          dispatch(setLastBookingsFromAPI(response?.data));
        }
      })
      .catch(() => {});
  };

  const handleFilter = () => {
    setShowFilter(true);
  };

  const handleCancel = () => {
    setShowFilter(false);
  };

  const onDelete = async () => {
    if (!bookings?.staffId) {
      return;
    }
    const content = `You are deleting Staff ${bookings?.staffId}. Are you sure you want to delete all information for this record?`;
    const canDelete = await new Promise((resolve, reject) => {
      showDialog("confirm", {
        title: "Warning",
        content: content,
        onConfirm: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });

    if (!canDelete) {
      return;
    }

    dispatch(deleteStaff(bookings?.staffId))
      .unwrap()
      .then(() => {
        notificationService.success(
          "Success!",
          "Staff data deleted successfully",
        );
        backToList();
      })
      .catch((error) => {
        notificationService.error("Error:", "Error deleting staff data");
      })
      .finally(() => {});
  };

  function backToList() {
    dispatch(setShowBookings(false));
    dispatch(setBookingsFieldsEnabled(false));
    setSaveVisible(false);
    dispatch(setBookingsNull());
  }

  const handleBackToList = () => {
    setBookingSearchPayload([
      { filterKey: "searchType", value: "Starts With" },
      { filterKey: "isActive", value: true },
      // { filterKey: "custodyStatus", value: "In Custody" },
    ]);
    setPagination({
      pageIndex: 0,
      pageSize: 100,
    });
    setTablePagination({
      pageIndex: 0,
      pageSize: 100,
    });
    setIsFiltered(false);
    dispatch(setShowBookings(false));
    setSearchTxt("");
  };

  const onNextClickTrigger = () => {
    nextBtnRef?.current?.onNextClick();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const columnKey = sorter?.order ? sorter.columnKey : "lName";
    const newSort = {
      orderBy: sortKeyMap[columnKey] ?? columnKey,
      direction:
        sorter?.order === "ascend"
          ? "asc"
          : sorter?.order === "descend"
            ? "desc"
            : "asc",
    };
    setSortInfo(newSort);
    if (isPageRef.current) {
      isPageRef.current = false;
      return;
    }
    getStaffList(newSort);
  };

  return (
    <>
      <StyledGridRow justify="space-between">
        <StyledGridCol span={24}>
          <StyledDarkSectionTitle bgColor="rgb(4 28 45)">
            <span>Staff</span>
          </StyledDarkSectionTitle>
        </StyledGridCol>
      </StyledGridRow>
      <StaffingContainer>
        {!fromFolderDetails && (
          <>
            {saveVisible ? (
              <StyledActionControlContainer
                className="action-control-container"
                headerHeight={headerHeight}
              >
                <div className="primary-control accent left">
                  <Button
                    color="warning"
                    variant="solid"
                    onClick={preSaveStaffAction}
                    disabled={isLoading}
                  >
                    Save Changes
                  </Button>
                  {showBookings && (
                    <Button
                      color="primary"
                      variant="solid"
                      onClick={onDelete}
                      loading={isDeleting}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.DELETE,
                          MODULES_LIST_WITH_ID.MODULE_STAFF,
                        )
                      }
                    >
                      Expunge
                    </Button>
                  )}
                </div>
                <div className="primary-control right">
                  <Button
                    color="primary"
                    type="primary"
                    variant="solid"
                    onClick={cancelStaffAction}
                  >
                    Cancel
                  </Button>
                </div>
              </StyledActionControlContainer>
            ) : (
              <ActionHeader
                style={{ marginBottom: "0px", paddingBottom: "15px" }}
              >
                <Flex gap={10}>
                  {showBookings && (
                    <Button
                      color="primary"
                      variant="solid"
                      onClick={modifyStaffAction}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.MODIFY,
                          MODULES_LIST_WITH_ID.MODULE_STAFF,
                        )
                      }
                    >
                      Modify
                    </Button>
                  )}
                  <Button
                    color="primary"
                    variant="solid"
                    onClick={onNewStaffBtnAction}
                    disabled={
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.module,
                        LABELS_CAPITAL.ADD,
                        MODULES_LIST_WITH_ID.MODULE_STAFF,
                      ) || isConfiguring
                    }
                  >
                    Create New
                  </Button>
                  {showBookings && (
                    <Button
                      color="primary"
                      type="primary"
                      variant="solid"
                      onClick={handleBackToList}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.VIEW,
                          MODULES_LIST_WITH_ID.MODULE_STAFF,
                        )
                      }
                    >
                      Back to List
                    </Button>
                  )}
                </Flex>
                {/* marginLeft: auto keeps this group pinned to the row's
                    right edge (mirrors Transport) regardless of whether
                    Show Filter/Clear Filter end up rendering - a bare
                    fragment here would leave individual buttons as direct
                    ActionHeader children, which its own space-between would
                    spread apart instead of keeping paired. */}
                <Flex gap={10} style={{ marginLeft: "auto" }}>
                  {showBookings && (
                    <Search
                      style={{ width: 300 }}
                      placeholder={"Search by Staff ID"}
                      allowClear
                      enterButton="Search"
                      onSearch={(e) => onSearch(e)}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.FIND,
                          MODULES_LIST_WITH_ID.MODULE_STAFF,
                        )
                      }
                    />
                  )}

                  {/* Config — reorder/resize columns; see gridId comment
                      above for why this deviates from legacy. Kept left of
                      Clear Filter/Show Filter so Show Filter stays the
                      row's rightmost button. */}
                  {!showBookings &&
                    hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.module,
                      LABELS_CAPITAL.VIEW,
                      MODULES_LIST_WITH_ID.MODULE_STAFF,
                    ) &&
                    (!isConfiguring ? (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        htmlType="button"
                        onClick={startConfiguring}
                      >
                        {configButtonLabel}
                      </Button>
                    ) : (
                      <Popconfirm
                        title="Do you want to save the current list view configuration?"
                        onConfirm={confirmSave}
                        onCancel={discardChanges}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          color="primary"
                          type="primary"
                          variant="solid"
                          htmlType="button"
                        >
                          {configButtonLabel}
                        </Button>
                      </Popconfirm>
                    ))}

                  {!showBookings && isFiltered && (
                    <Button
                      color="primary"
                      type="primary"
                      variant="solid"
                      onClick={handleBackToList}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.VIEW,
                          MODULES_LIST_WITH_ID.MODULE_STAFF,
                        ) || isConfiguring
                      }
                    >
                      Clear Filter
                    </Button>
                  )}

                  {!showBookings &&
                    hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.module,
                      LABELS_CAPITAL.VIEW,
                      MODULES_LIST_WITH_ID.MODULE_STAFF,
                    ) && (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        onClick={handleFilter}
                        disabled={
                          !hasCheckSecurity(
                            Security_Types.functionality,
                            Entity_types.module,
                            LABELS_CAPITAL.FIND,
                            MODULES_LIST_WITH_ID.MODULE_STAFF,
                          ) || isConfiguring
                        }
                      >
                        Show Filter
                      </Button>
                    )}
                </Flex>
              </ActionHeader>
            )}
          </>
        )}
        <BookingsFilter
          isFindModalVisible={showFilter}
          setIsFindModalVisible={setShowFilter}
          setBookingSearchPayload={setBookingSearchPayload}
          onHandleCancel={handleCancel}
          setReportListData={setReportListData}
          setReportListTotal={setReportListTotal}
          setPagination={setPagination}
          setIsFiltered={setIsFiltered}
          apiModule={MODULES_LIST.STAFF}
          path={MODULES_LIST.STAFF}
        />

        {showBookings ? (
          <>
            <Spin spinning={isLoading} className="text-white" tip="Loading...">
              <div className="staffing-content-wrapper">
                <InmateHeader
                  defaultInfo={false}
                  customInfo={<StaffingBasicInfo />}
                  inmateMainTitle="EHR-SYSTEM, INTERFACE"
                  parentKey="staff"
                  fromFolderDetails={fromFolderDetails}
                />

                <CreateStaffing
                  allFormRef={allFormRef}
                  onNextClickTrigger={onNextClickTrigger}
                  nextBtnRef={nextBtnRef}
                  tabChangeRef={tabChangeRef}
                  startingPoint="Staff"
                />
              </div>
            </Spin>
          </>
        ) : (
          <>
            {hasCheckSecurity(
              Security_Types.functionality,
              Entity_types.module,
              LABELS_CAPITAL.VIEW,
              MODULES_LIST_WITH_ID.MODULE_STAFF,
            ) ? (
              <DataTable
                ref={dataTableRef}
                draggable={isConfiguring}
                rowUniqueId={"staffId"}
                allowTableSorting={true}
                serverSideSorting={true}
                onTableChange={handleTableChange}
                headers={staffingHeaders}
                data={reportListData?.rows || []}
                width="100%"
                className="table-striped"
                selectionColumnVisible={false}
                isAPiCallLoading={loadingAPI}
                onRowClick={handleRowClick}
                pagination={pagination}
                setPagination={setPagination}
                totalRecords={reportListTotal}
                onPageChange={handleChangePagination}
              />
            ) : (
              <NoAccess moduleName={"staff"} />
            )}
          </>
        )}
      </StaffingContainer>
    </>
  );
};

export default Staffing;
